exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ntr.selected[data-v-30d2ef04] {\n    background-color: #1890ff1c !important;\n}\n", ""]);

// exports
